import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useLoanGroupForm = (onSubmit, values) => {
  const isEdit = !!values;

  const fields = useMemo(
    () => [
      {
        title: isEdit ? 'Edit Loan Group' : 'New Loan Group',
        fields: [
          {
            title: 'Date',
            name: 'date',
            type: 'date',
            required: true,
          },
          {
            title: 'Name',
            name: 'name',
            type: 'text',
            required: true,
            maxLength: 60,
          },
          {
            title: 'Description',
            name: 'description',
            type: 'textarea',
            maxLength: 500,
            rows: 3,
            className: 'xl:col-span-2',
          },
        ],
      },
    ],
    [isEdit]
  );

  return useForm({ fields, onSubmit, values });
};

export default useLoanGroupForm;
